import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PortNumbersPortingFormDetails} from "../port-phonenumber.model";

@Component({
    selector: 'app-phonenumber-port',
    templateUrl: './phonenumber-port.component.html',
    standalone: false
})
export class PhonenumberPortComponent implements OnInit {

  @Input()
  public countryCode: string;

  @Output()
  public selected = new EventEmitter<PortNumbersPortingFormDetails>();

  @Output() back: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit(): void {
  }
  
}
